module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAABgSURBVDhPYxj0QAWIxSBM8kAmENtAmOSBUQPINKAciIUhTBQDFIE4B8LEDxSAeAMQgwyBGQDSDBITAmKiAEjDRiCuAeI4IIYZSBIAGXIbiI8DMcmaYQDkHbI10wMwMAAAVpQMuAdvWa0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/DownArrow.png
// module id = 670
// module chunks = 0